import React from 'react';
import { Divider } from '@gasbuddy/react-components';
import styles from './styles.css';
import StarRating from '../../star-rating';
import { StationRatingsType } from '../../../utils/prop-types/rating-types';

class StarRatingCard extends React.Component {
  static propTypes = {
    stationRatings: StationRatingsType.isRequired,
    priorPeriodStationRatings: StationRatingsType.isRequired,
  };

  getStarRatingTrendText = () => {
    const { stationRatings, priorPeriodStationRatings } = this.props;
    const starRatingTrend = (stationRatings.star_rating - priorPeriodStationRatings.star_rating).toFixed(1);
    let starRatingTrendText = 'NO CHANGE';
    if (starRatingTrend > 0) {
      starRatingTrendText = `UP ${starRatingTrend}`;
    } else if (starRatingTrend < 0) {
      starRatingTrendText = `DOWN ${starRatingTrend}`;
    }

    return starRatingTrendText;
  }

  render = () => {
    const { stationRatings } = this.props;

    return (
      <div className={styles.starRatingContainer}>
        <div className={styles.contents}>
          <div className={styles.starRating}>{stationRatings.star_rating.toFixed(1)}</div>
          <StarRating
            starCount={stationRatings.star_rating}
            size="lg"
          />
          <div className={styles.trend}>
            {`${this.getStarRatingTrendText()} OVER THE PRIOR PERIOD`}
          </div>
        </div>
        <Divider />
        <div className={styles.footer}>
          Star rating is based on
          {' '}
          {stationRatings.ratings_count_for_star_rating}
          {' '}
          total all time ratings
        </div>
      </div>
    );
  }
}

export default StarRatingCard;
